import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { BatchColumnsService } from '../../shared/column/batch-columns.service';
import { BatchService } from '../../../data/batch.service';
import { TableColumnService } from '../../shared/services/table-column.service';
import { BatchData } from './batch.data';
import { batchTableRequest } from 'src/app/store/batch-table/batch-table.actions';
import { ShipmentStatusEnum } from '../../../enum/shipment-status.enum';
import { shipmentTableChangeQuery } from '../../../store/shipments-table/shipments-table.actions';
import { Router } from '@angular/router';
import { BatchTableService } from '../../shared/tables/batch-table.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-batch-table',
    templateUrl: './batch-table.component.html',
    styleUrls: ['./batch-table.component.scss'],
    imports: [MatProgressSpinner, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, MatSortHeader, MatButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, AsyncPipe]
})
export class BatchTableComponent implements OnInit {

    constructor(private store: Store<AppState>, private batchService: BatchService,
                private tableColumnService: TableColumnService, private batchColumns: BatchColumnsService,
                private router: Router, public table: BatchTableService) {
    }

    dataSource = new BatchData(this.table.currentPageEntries$);

    ngOnInit(): void {
        this.store.dispatch(batchTableRequest());
    }

    viewShipments(id: string): void {
        const query = {
            state: ShipmentStatusEnum.ANY,
            pageNumber: 1,
            itemsPerPage: null,
            sortColumn: null,
            sortDescending: null,
            afterDate: null,
            beforeDate: null,
            filter: null,
            courier: null,
            serviceId: null,
            shipper: [],
            destination: [],
            batchId: id
        };
        this.store.dispatch(shipmentTableChangeQuery({ query }));
        this.router.navigate(['shipments']).then();
    }
}
